export const ANDAR_BAHAR_ID = 38;
export const ANDAR_BAHAR_OTT_ID = 39;
export const ANDAR_BAHAR_ULTIMATE_ID = 55;
export const ANDAR_BAHAR_IDS = [ ANDAR_BAHAR_ID, ANDAR_BAHAR_OTT_ID, ANDAR_BAHAR_ULTIMATE_ID ] as const;
export const BACCARAT_ID = 2;
export const BACCARAT_KO_ID = 20;
export const BACCARAT_SUPER_SIX_ID = 21;
export const BACCARAT_MULTI_SEAT_ID = 22;
export const BACCARAT_INSURANCE_ID = 23;
export const BACCARAT_DRAGON_TIGER_ID = 24;
export const BACCARAT_NO_COMMISSION_ID = 25;
export const BACCARAT_DRAGON_BONUS_ID = 26;
export const BACCARAT_QUEENCO_ID = 27;
export const BACCARAT_PUNTO_BANCO_ID = 28;
export const BACCARAT_CRICKET_WAR_ID = 45;
export const EZ_BACCARAT_ID = 70;
export const BACCARAT_IDS = [
  BACCARAT_ID,
  BACCARAT_KO_ID,
  BACCARAT_DRAGON_TIGER_ID,
  BACCARAT_NO_COMMISSION_ID,
  BACCARAT_DRAGON_BONUS_ID,
  BACCARAT_QUEENCO_ID,
  BACCARAT_CRICKET_WAR_ID,
  BACCARAT_MULTI_SEAT_ID,
  BACCARAT_INSURANCE_ID,
  BACCARAT_PUNTO_BANCO_ID,
  BACCARAT_SUPER_SIX_ID,
  EZ_BACCARAT_ID,
] as const;
export const BET_ON_TEEN_PATTI_ID = 16;
export const BLACKJACK_ID = 1;
export const BLACKJACK_AMERICAN_ID = 10;
export const BLACKJACK_AMERICAN_HYBRID_ID = 11;
export const BLACKJACK_UNLIMITED_ID = 12;
export const BLACKJACK_SALON_PRIVE_ID = 46;
export const BLACKJACK_HYBRID_ID = 5;
export const BLACKJACK_RIDE_FREE_ID = 65;
export const BLACKJACK_IDS = [
  BLACKJACK_ID,
  BLACKJACK_AMERICAN_ID,
  BLACKJACK_UNLIMITED_ID,
  BLACKJACK_SALON_PRIVE_ID,
  BLACKJACK_HYBRID_ID,
  BLACKJACK_AMERICAN_HYBRID_ID,
  BLACKJACK_RIDE_FREE_ID,
] as const;
export const CASINO_HOLDEM_ID = 15;
export const LUCKY7_ID = 13;
export const ONE_DAY_TEEN_PATTI_ID = 43;
export const ONE_DAY_TEEN_PATTI_BACK_AND_LAY_ID = 50;
export const ONE_DAY_TEEN_PATTI_IDS = [ ONE_DAY_TEEN_PATTI_ID, ONE_DAY_TEEN_PATTI_BACK_AND_LAY_ID ] as const;
export const ROULETTE_ID = 3;
export const ROULETTE_AUTOMATED_ID = 7;
export const ROULETTE_PORTOMASO_ID = 29;
export const ROULETTE_AMERICAN_ID = 31;
export const ROULETTE_AMERICAN_AUTO_ID = 32;
export const ROULETTE_AMERICAN_OTT_ID = 35;
export const ROULETTE_RNG_ID = 48;
export const ROULETTE_ULTIMATE_ID = 54;
export const ROULETTE_REVOLUTION_ID = 58;
export const ROULETTE_REVOLUTION_US_ID = 61;
export const TRIPLE_ZERO_ROULETTE_ID = 63;
export const CLAW_ROULETTE_ID = 71;
export const ROULETTE_IDS = [
  ROULETTE_ID,
  ROULETTE_AUTOMATED_ID,
  ROULETTE_PORTOMASO_ID,
  ROULETTE_AMERICAN_ID,
  ROULETTE_AMERICAN_AUTO_ID,
  ROULETTE_AMERICAN_OTT_ID,
  ROULETTE_RNG_ID,
  ROULETTE_ULTIMATE_ID,
  ROULETTE_REVOLUTION_ID,
  ROULETTE_REVOLUTION_US_ID,
  CLAW_ROULETTE_ID,
  TRIPLE_ZERO_ROULETTE_ID,
] as const;
export const SICBO_ID = 14;
export const SICBO_ULTIMATE_ID = 52;
export const SICBO_AUTO_ID = 44;
export const SICBO_IDS = [ SICBO_ID, SICBO_ULTIMATE_ID, SICBO_AUTO_ID ] as const;
export const THREE_CARD_POKER_ID = 17;
export const MATKA_ID = 57;
export const MARBLE_RACE_ID = 59;
export const ARCADIA_CLAW_ROULETTE_ID = 10002;
export const ARCADIA_MAGIC_CLAW_ID = 10003;
export const ARCADIA_FORTUNE_PUSHER_ID = 10004;
export const ARCADIA_IDS = [ ARCADIA_CLAW_ROULETTE_ID, ARCADIA_MAGIC_CLAW_ID, ARCADIA_FORTUNE_PUSHER_ID ] as const;
export const XOC_DIA_ID = 60;
export const XOC_DIA_MULTIPLIERS_ID = 62;
export const XOC_DIA_IDS = [ XOC_DIA_ID, XOC_DIA_MULTIPLIERS_ID ] as const;
export const ULTIMATE_DICE_ID = 64;
export const BONUS_GAME_ID = 49;
export const BIG_COCK_KNOCKOUT_ID = 72;

/** ids of discontinued games for which rounds played in the past are still available in player history */
export const DISCONTINUED_GAMES = {
  THIRTY_TWO_CARDS_ID: 19,
  BLACKJACK_VIDEOCHAT_ID: 51,
  RUSSIAN_POKER_ID: 53,
} as const;

export const PORTRAIT_ONLY_GAME_IDS = [ CLAW_ROULETTE_ID ];

// ids of old, discontinued games
// for which rounds played in the past are not available in player history (tv links, games never launched):

// LOTTERY_ID               =  4
// KENO_ID                  =  6
// BET_ON_ROULETTE_OMSBS_ID = 30
// LOTTERY_OMSBS_ID         = 34
// KENO_OMSBS_ID            = 36
// PARTOUCHE_OMSBS_ID       = 37
// GOLDEN_BALLS_OMSBS_ID    = 40
// DREAM_CATCHER_OMSBS_ID   = 47
// MARBLE_RACE_RETAIL_ID    = 65 (never launched)

export const REDESIGNED_BACCARAT_GAME_IDS = [
  BACCARAT_ID,
  BACCARAT_KO_ID,
  BACCARAT_NO_COMMISSION_ID,
  BACCARAT_DRAGON_BONUS_ID,
  BACCARAT_QUEENCO_ID,
  BACCARAT_SUPER_SIX_ID,
  EZ_BACCARAT_ID,
];
